'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOfficeHoursEmailCapturePromptMessage = undefined;

var _both = require('transmute/both');

var _both2 = _interopRequireDefault(_both);

var _isEmailCapturePromptMessage = require('./isEmailCapturePromptMessage');

var _sentOutsideOfficeHours = require('./sentOutsideOfficeHours');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isOfficeHoursEmailCapturePromptMessage = exports.isOfficeHoursEmailCapturePromptMessage = (0, _both2.default)(_isEmailCapturePromptMessage.isEmailCapturePromptMessage, _sentOutsideOfficeHours.sentOutsideOfficeHours);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isOfficeHoursEmailCapturePromptMessage.js
// module id = 1090
// module chunks = 2 3